import { AvailabilityStates } from '@coolblue-development/next-availability-state';
import { Collection } from '@features/product/components/Collection/Collection.types';

export const matchPropertyValues = (collection: Collection, productId?: number): Collection => {
  if (!productId) {
    return collection;
  }

  const currentProductValues = [];

  const mappedCollection = {
    ...collection,
    discriminants: collection.discriminants.map(discriminant => ({
      ...discriminant,
      values: discriminant.values.map(value => {
        const productIds = value.products
          .filter(product => product !== null)
          .map(product => product?.id);
        return {
          ...value,
          productIds: productIds ?? []
        };
      })
    }))
  };

  for (const discriminant of mappedCollection.discriminants) {
    for (const value of discriminant.values) {
      if (value.productIds?.includes(productId)) {
        currentProductValues.push(value);
      }
    }
  }

  const matchingPerProductId: { [key: number]: number } = {};

  for (const discriminant of mappedCollection.discriminants) {
    for (const value of discriminant.values) {
      for (const productId of value?.productIds ?? []) {
        if (!matchingPerProductId[productId]) {
          matchingPerProductId[productId] = 0;
        }

        if (currentProductValues.includes(value)) {
          matchingPerProductId[productId] = matchingPerProductId[productId] + 1;
        }
      }
    }
  }

  return {
    ...collection,
    discriminants: collection.discriminants.map(discriminant => ({
      ...discriminant,
      values: discriminant.values.map(value => {
        const products = value.products
          .filter(product => product !== null)
          .map(product => ({
            ...product,
            /* A product is only a viable redirect option if it matches at least all other discriminant values of the current product
            and is not permanently out of stock */
            shouldRedirect:
              matchingPerProductId[product.id] >= collection.discriminants.length - 1 &&
              product?.nullableAvailabilityState !== AvailabilityStates.OutOfStock
          }))
          .sort((a, b) => matchingPerProductId[b.id] - matchingPerProductId[a.id]);

        const filteredValue = [...value.products].filter(
          product => product?.nullableAvailabilityState !== AvailabilityStates.OutOfStock
        );

        return {
          ...value,
          products,
          shouldShowValue: filteredValue.length > 0,
          product:
            products.find(
              product =>
                product !== null &&
                product.nullableAvailabilityState !== AvailabilityStates.OutOfStock
            ) ?? null
        };
      })
    }))
  };
};
